import { RESERVED_TAGS } from '../constants/constants';

const isAITag = (value?: string) => {
  return value
    ?.trim()
    ?.toUpperCase()
    ?.startsWith(RESERVED_TAGS.AI.toUpperCase());
};

const isRetrievalTag = (value?: string) => {
  return value
    ?.trim()
    ?.toUpperCase()
    ?.startsWith(RESERVED_TAGS.RETRIEVAL.toUpperCase());
};

const getRetrievalTagValue = (tag: string | null | undefined) => {
  const retrievalSeparator = RESERVED_TAGS.RETRIEVAL.charAt(
    RESERVED_TAGS.RETRIEVAL.length - 1
  );
  return tag?.split(retrievalSeparator)[1];
};

// Check if flag is type of Key Idea
const isKeyIdeaFlag = (keyIdea: string[] | null) => {
  if (keyIdea && keyIdea?.length > 0) {
    return true;
  } else {
    return false;
  }
};

/**
 * Validates a given tag to ensure it does not match any reserved tags or use disallowed characters.
 * If the tag is invalid, it returns false and a corresponding error message.
 *
 * @param tag - The tag value to validate.
 * @returns [boolean, string | null] - Returns [false, message] if the tag is invalid, [true, null] otherwise.
 */
const validateTagInput = (tag?: string): [boolean, string | null] => {
  const { MY_AUDIO_FEEDBACK, UNTAGGED, UPTAG, DOWNTAG } = RESERVED_TAGS;

  if (tag === MY_AUDIO_FEEDBACK) {
    return [
      false,
      'This word is reserved for feedback flags. Please choose another tag name.'
    ];
  }
  if (tag === UNTAGGED) {
    return [
      false,
      'This word is reserved for untagged flags. Please choose another tag name.'
    ];
  }
  if (isAITag(tag)) {
    return [
      false,
      'This word is reserved for AI flags. Please choose another tag name.'
    ];
  }
  if (isRetrievalTag(tag)) {
    return [
      false,
      'This word is reserved for special flags. Please choose another tag name.'
    ];
  }
  if (tag === UPTAG || tag === DOWNTAG) {
    return [
      false,
      'This word is reserved for thumbs up/thumbs down flags. Please choose another tag name.'
    ];
  }
  if (tag?.includes(',')) {
    return [false, 'Use of comma character "," is not allowed.'];
  }

  return [true, null];
};

export {
  getRetrievalTagValue,
  isAITag,
  isRetrievalTag,
  validateTagInput,
  isKeyIdeaFlag
};
